'use client';

import { CardContent, CardDescription, CardHeader, CardTitle, HoverCard, HoverCardContent, HoverCardTrigger } from '@sushiswap/ui';
import { ShuffleIcon } from '@sushiswap/ui/icons/ShuffleIcon';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { isTwapSupportedChainId } from 'src/config';
import { ChainId, ChainKey } from 'sushi/chain';
import { isSushiXSwap2ChainId } from 'sushi/config';
import { PathnameButton } from '../pathname-button';
export const SwapModeButtons = () => {
  const {
    chainId: _chainId
  } = useParams();
  const chainId = (+_chainId as ChainId);
  return <div className="flex gap-2 flex-wrap" data-sentry-component="SwapModeButtons" data-sentry-source-file="swap-mode-buttons.tsx">
      <Link href={`/${ChainKey[chainId]}/swap`} data-sentry-element="Link" data-sentry-source-file="swap-mode-buttons.tsx">
        <PathnameButton pathname={`/${ChainKey[chainId]}/swap`} size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="swap-mode-buttons.tsx">
          Swap
        </PathnameButton>
      </Link>
      <Link href={`/${isTwapSupportedChainId(chainId) ? ChainKey[chainId] : 'ethereum'}/limit`} data-sentry-element="Link" data-sentry-source-file="swap-mode-buttons.tsx">
        <PathnameButton pathname={`/${ChainKey[chainId]}/limit`} size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="swap-mode-buttons.tsx">
          Limit
        </PathnameButton>
      </Link>
      <Link href={`/${isTwapSupportedChainId(chainId) ? ChainKey[chainId] : 'ethereum'}/dca`} data-sentry-element="Link" data-sentry-source-file="swap-mode-buttons.tsx">
        <PathnameButton pathname={`/${ChainKey[chainId]}/dca`} size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="swap-mode-buttons.tsx">
          DCA
        </PathnameButton>
      </Link>
      <HoverCard data-sentry-element="HoverCard" data-sentry-source-file="swap-mode-buttons.tsx">
        <Link href={`/${isSushiXSwap2ChainId(chainId) ? ChainKey[chainId] : 'ethereum'}/cross-chain-swap`} data-sentry-element="Link" data-sentry-source-file="swap-mode-buttons.tsx">
          <PathnameButton pathname={`/${ChainKey[chainId]}/cross-chain-swap`} size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="swap-mode-buttons.tsx">
            <HoverCardTrigger asChild data-sentry-element="HoverCardTrigger" data-sentry-source-file="swap-mode-buttons.tsx">
              <span className="saturate-200 flex items-center gap-2 bg-gradient-to-r from-blue to-pink bg-clip-text text-transparent">
                <ShuffleIcon width={20} height={20} className="text-blue" data-sentry-element="ShuffleIcon" data-sentry-source-file="swap-mode-buttons.tsx" />
                Cross-Chain
              </span>
            </HoverCardTrigger>
          </PathnameButton>
        </Link>
        <HoverCardContent className="!p-0 max-w-[320px]" data-sentry-element="HoverCardContent" data-sentry-source-file="swap-mode-buttons.tsx">
          <CardHeader data-sentry-element="CardHeader" data-sentry-source-file="swap-mode-buttons.tsx">
            <CardTitle data-sentry-element="CardTitle" data-sentry-source-file="swap-mode-buttons.tsx">Cross-Chain Swap</CardTitle>
            <CardDescription data-sentry-element="CardDescription" data-sentry-source-file="swap-mode-buttons.tsx">
              Swap tokens natively across 15 chains including Ethereum,
              Arbitrum, Optimism, Polygon, Base and more!
            </CardDescription>
          </CardHeader>
          <CardContent data-sentry-element="CardContent" data-sentry-source-file="swap-mode-buttons.tsx">
            <a target="_blank" className="text-sm text-blue hover:underline" href="https://www.sushi.com/blog/sushixswap-v2" rel="noreferrer">
              Learn more.
            </a>
          </CardContent>
        </HoverCardContent>
      </HoverCard>
    </div>;
};